import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatBadgeModule } from '@angular/material/badge';
import { AsyncPipe, NgStyle } from '@angular/common';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { LoginService } from '../services/login.service';

@Component({
  selector: 'app-header',
  imports: [
    MatToolbarModule,
    MatIconModule,
    MatMenuModule,
    MatButtonModule,
    MatDividerModule,
    MatBadgeModule,
    RouterLink,
    AsyncPipe,
    NgStyle
],
  standalone: true,
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  #loginService = inject(LoginService);

  name = environment.appName;
  logo = environment.logo;
  logoStyle = environment.logoStyle;
  appUrl = environment.appUrl;
  showPoweredBy = environment.whiteLabel;
  userName = 'John Doe'; // Placeholder for user name
  isUserLoggedIn$: Observable<boolean>;

  constructor() {
    this.isUserLoggedIn$ = this.#loginService.isLoggedIn();
    
    this.isUserLoggedIn$.subscribe((isLoggedIn) => {
      if (isLoggedIn) {
        this.userName = (this.#loginService.loginUser ? `${this.#loginService.loginUser.Firstname} ${this.#loginService.loginUser.Lastname}` : 'Test User');
      }
    });
  }

  onLogout(): void {
    // Placeholder for logout functionality
    console.log('Logout clicked');
    this.#loginService.logout();
  }
}
